<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-12 16:44:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-26 11:47:14
 * @FilePath: \mrc-base-server-view\src\views\data-access-strategy\modules\columnTabs.vue
-->
<template>
  <div class="d-flex"
       style="background-color: #eeeef0;">
    <v-card style="border-radius: 8px;width: 280px;background-color: #eeeef0;"
            elevation="0">
      <v-tabs vertical
              v-model="tab">
        <v-tab v-for="(item,index) in tabList"
               class="pa-0 text-capitalize"
               style="height:52px;width: 280px"
               :key="index">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs"
                   v-on="on"
                   style="width: 250px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-align: left;">{{index+1}}.{{item.title}}
              </div>
            </template>
            <span> {{index+1}}.{{ item.title }}</span>
          </v-tooltip>
        </v-tab>
      </v-tabs>
    </v-card>
    <v-card style='flex: 1;background-color: #eeeef0;border-radius: 8px'
            class='ml-4'
            elevation="0">
      <v-tabs-items v-model="tab">
        <!-- 查看自己录入数据 -->
        <v-tab-item>
          <viewYourOwnData ref="oneRef"
                           :readonly='readonly'
                           @cancel='cancel'
                           @success='success'></viewYourOwnData>
        </v-tab-item>

        <!-- 查看下属人员数据 -->
        <v-tab-item>
          <viewDataOfSubordinates ref="twoRef"
                                  @updateSuccess='updateSuccess'
                                  :readonly='readonly'
                                  @success='success'
                                  @cancel='cancel'></viewDataOfSubordinates>
        </v-tab-item>

        <!-- 查看同岗位人员数据 -->
        <v-tab-item>
          <viewDataOfEmployeesInTheSamePosition @success='success'
                                                @updateSuccess='updateSuccess'
                                                ref="threeRef"
                                                :readonly='readonly'
                                                @cancel='cancel'></viewDataOfEmployeesInTheSamePosition>
        </v-tab-item>

        <!-- 查看被代理岗位人员数据录入数据 -->
        <v-tab-item>
          <viewDataOfDelegatedPersonnel ref="fourRef"
                                        @updateSuccess='updateSuccess'
                                        :readonly='readonly'
                                        @success='success'
                                        @cancel='cancel'></viewDataOfDelegatedPersonnel>
        </v-tab-item>

        <!-- 指定岗位查看指定组织架构人员数据 -->
        <v-tab-item>
          <viewDataOfDesignOrganizationalStructureAtDesignatedPositions ref="fiveRef"
                                                                        @updateSuccess='updateSuccess'
                                                                        :readonly='readonly'
                                                                        @success='success'
                                                                        @cancel='cancel'></viewDataOfDesignOrganizationalStructureAtDesignatedPositions>
        </v-tab-item>

        <!-- 指定人员查看指定岗位人员数据 -->
        <v-tab-item>
          <designatedPersonnelToViewPersonnelDataOfDesignatedPositions ref="sixRef"
                                                                       @updateSuccess='updateSuccess'
                                                                       :readonly='readonly'
                                                                       @success='success'
                                                                       @cancel='cancel'></designatedPersonnelToViewPersonnelDataOfDesignatedPositions>
        </v-tab-item>

        <!-- 指定人员查看指定组织架构人员数据 -->
        <v-tab-item>
          <designatedPersonnelViewShDataOfDesianatedOrganizationalStructurePersonnel ref="sevenRef"
                                                                                     :readonly='readonly'
                                                                                     @updateSuccess='updateSuccess'
                                                                                     @success='success'
                                                                                     @cancel='cancel'></designatedPersonnelViewShDataOfDesianatedOrganizationalStructurePersonnel>
        </v-tab-item>

        <!-- 指定人员查看指定人员错误 -->
        <v-tab-item>
          <designatedPersonnelToViewDesignatedPersonnelData ref="eightRef"
                                                            :readonly='readonly'
                                                            @updateSuccess='updateSuccess'
                                                            @success='success'
                                                            @cancel='cancel'></designatedPersonnelToViewDesignatedPersonnelData>
        </v-tab-item>

      </v-tabs-items>
      <!-- <mrc_ess_submitBtn @success='success'
                         :cancelText="$store.state.uuid?'取消':$t('label_The_previous_step')"
                         @cancel='cancel'></mrc_ess_submitBtn> -->
    </v-card>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  listData,
  getData,
  updateData,
  addData,
  delData
} from '@/service/api/data-access-strategy'
import viewDataOfSubordinates from './viewDataOfSubordinates'
import viewYourOwnData from './viewYourOwnData'
import viewDataOfEmployeesInTheSamePosition from './viewDataOfEmployeesInTheSamePosition'
import viewDataOfDelegatedPersonnel from './viewDataOfDelegatedPersonnel'
import designatedPersonnelViewShDataOfDesianatedOrganizationalStructurePersonnel from './designatedPersonnelViewShDataOfDesianatedOrganizationalStructurePersonnel'
import designatedPersonnelToViewPersonnelDataOfDesignatedPositions from './designatedPersonnelToViewPersonnelDataOfDesignatedPositions'
import designatedPersonnelToViewDesignatedPersonnelData from './designatedPersonnelToViewDesignatedPersonnelData'
import viewDataOfDesignOrganizationalStructureAtDesignatedPositions from './viewDataOfDesignOrganizationalStructureAtDesignatedPositions'
export default {
  components: {
    viewDataOfSubordinates,
    viewYourOwnData,
    viewDataOfEmployeesInTheSamePosition,
    viewDataOfDelegatedPersonnel,
    designatedPersonnelViewShDataOfDesianatedOrganizationalStructurePersonnel,
    designatedPersonnelToViewPersonnelDataOfDesignatedPositions,
    designatedPersonnelToViewDesignatedPersonnelData,
    viewDataOfDesignOrganizationalStructureAtDesignatedPositions
  },
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    baseInfo: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      tab: 0,
      mrbase_sys_data_strategy_subordinate: [],//查看下属人员数据
      mrbase_sys_data_strategy_same_post_grade: [], //查看同岗位人员数据
      mrbase_sys_data_strategy_post_onbehalf: [],//查看被代理岗位人员数据录入数据
      mrbase_sys_data_strategy_specified_post_toorg: [],//指定岗位查看指定组织架构人员数据
      mrbase_sys_data_strategy_specified_staff_topost: [],//指定人员查看指定岗位人员数据
      mrbase_sys_data_strategy_specified_staff_toorg: [],//指定人员查看指定组织架构人员数据
      mrbase_sys_data_strategy_specified_staff_tostaffs: [],//指定人员查看指定人员数据
    };
  },
  validations: {},
  computed: {
    tabList () {
      return [
        {
          title: this.$t('label_View_your_own_data'),
          tableName: ''
        },
        {
          title: this.$t('label_View_data_of_subordinates'),
          tableName: ''
        },
        {
          title: this.$t('label_View_data_of_employees_in_the_same_position'),
          tableName: ''
        },
        {
          title: this.$t('label_View_the_data_of_delegated_personnel'),
          tableName: ''
        },
        {
          title: this.$t('label_View_the_personnel_data_of_the_designated_organization'),
          tableName: ''
        },
        {
          title: this.$t('label_Designated_personnel_to_view_personnel_data'),
          tableName: ''
        },
        {
          title: this.$t('label_designated_personnel_to_view_personnel_data_of_designated_organizational_structure'),
          tableName: ''
        },
        {
          title: this.$t('label_DpV_designated_personnel_data'),
          tableName: ''
        },
      ]
    }
  },
  created () { },
  watch: {},
  mounted () { },

  methods: {
    async success (val, val2) {
      if (this.$store.state.uuid) {//修改
        // if (this.tab == 0) {//查看自己录入数据
        // }
        // if (this.tab == 1) {//查看下属人员数据

        // }
        // if (this.tab == 2) {//查看同岗位人员数据
        //   this.mrbase_sys_data_strategy_same_post_grade = val
        // }
        // if (this.tab == 3) {//查看被代理岗位人员数据录入数据
        //   this.mrbase_sys_data_strategy_post_onbehalf = val
        // }
        // if (this.tab == 4) {//指定岗位查看指定组织架构人员数据
        //   this.mrbase_sys_data_strategy_specified_post_toorg = val
        // }
        // if (this.tab == 5) {//指定人员查看指定岗位人员数据
        //   this.mrbase_sys_data_strategy_specified_staff_topost = val
        // }
        // if (this.tab == 6) {//指定人员查看指定组织架构人员数据
        //   this.mrbase_sys_data_strategy_specified_staff_toorg = val
        // }
        // if (this.tab == 7) {//指定人员查看指定人员错误
        //   this.mrbase_sys_data_strategy_specified_staff_tostaffs = val
        // }
      }
      else {//新增 
        // console.log(this.baseInfo);
        const obj = {
          "mrbase_sys_data_strategy_subordinate_properties": "002",//是否上级查看所有下级数据权限 策略uuid
          "mrbase_sys_data_strategy_same_post_grade_properties": "003", //同岗位的相互查看数据权限 策略uuid
          "mrbase_sys_data_strategy_post_onbehalf_properties": "004", //查看被代理岗位人员数据 策略uuid
          "mrbase_sys_data_strategy_specified_post_toorg_properties": "005",//指定岗位可以查看指定组织架构 策略uuid
          "mrbase_sys_data_strategy_specified_staff_tostaffs_properties": "006", //指定某个人能看具体哪几个人的数据权限 策略uuid
          "mrbase_sys_data_strategy_specified_staff_topost_properties": "007",//指定人员查看指定岗位人员数据 策略uuid
          "mrbase_sys_data_strategy_specified_staff_toorg_properties": "008",//指定人员查看指定组织机构人员数据 策略 uuid
          "mrbase_sys_data_strategy_subordinate_is_used": "0", //是否上级查看所有下级数据权限 是否启用 0 否 1 是
          "mrbase_sys_data_strategy_same_post_grade_is_used": "0", //同岗位的相互查看数据权限 是否启用 1 是 0 否
          "mrbase_sys_data_strategy_post_onbehalf_is_used": "0",//查看被代理岗位人员数据 是否启用 1 是 0 否
          "mrbase_sys_data_strategy_specified_post_toorg_is_used": "0",//指定岗位可以查看指定组织架构 是否启用 1 是 0 否
          "mrbase_sys_data_strategy_specified_staff_topost_is_used": "0", //指定人员查看指定岗位人员数据  是否启用 1 是 0 否
          "mrbase_sys_data_strategy_specified_staff_toorg_is_used": "0",//指定人员查看指定组织机构人员数据 是否启用 1 是 0 否 
          "mrbase_sys_data_strategy_specified_staff_tostaffs_is_used": "0", //指定某个人能看具体哪几个人的数据权限 是否启用 1 是  0  否
          mrbase_sys_data_strategy_subordinate: [],
          mrbase_sys_data_strategy_same_post_grade: [],
          mrbase_sys_data_strategy_post_onbehalf: [],
          mrbase_sys_data_strategy_specified_post_toorg: [],
          mrbase_sys_data_strategy_specified_staff_topost: [],
          mrbase_sys_data_strategy_specified_staff_toorg: [],
          mrbase_sys_data_strategy_specified_staff_tostaffs: [],
        }
        if (this.$refs.twoRef) {
          obj.mrbase_sys_data_strategy_subordinate_is_used = this.$refs.twoRef.dataobj.mrbase_sys_data_strategy_subordinate_is_used
          obj.mrbase_sys_data_strategy_subordinate = this.$refs.twoRef.list[0].exclude_function_uuids == '' ? [] : this.$refs.twoRef.list
        }
        if (this.$refs.threeRef) {
          obj.mrbase_sys_data_strategy_same_post_grade_is_used = this.$refs.threeRef.dataobj.mrbase_sys_data_strategy_same_post_grade_is_used
          obj.mrbase_sys_data_strategy_same_post_grade = this.$refs.threeRef.list
        }
        if (this.$refs.fourRef) {
          obj.mrbase_sys_data_strategy_post_onbehalf_is_used = this.$refs.fourRef.dataobj.mrbase_sys_data_strategy_post_onbehalf_is_used
          obj.mrbase_sys_data_strategy_post_onbehalf = this.$refs.fourRef.list
        }
        if (this.$refs.fiveRef) {
          obj.mrbase_sys_data_strategy_specified_post_toorg_is_used = this.$refs.fiveRef.dataobj.mrbase_sys_data_strategy_specified_post_toorg_is_used
          obj.mrbase_sys_data_strategy_specified_post_toorg = this.$refs.fiveRef.list
        }
        if (this.$refs.sixRef) {
          obj.mrbase_sys_data_strategy_specified_staff_topost_is_used = this.$refs.sixRef.dataobj.mrbase_sys_data_strategy_specified_staff_topost_is_used
          obj.mrbase_sys_data_strategy_specified_staff_topost = this.$refs.sixRef.list
        }
        if (this.$refs.sevenRef) {
          obj.mrbase_sys_data_strategy_specified_staff_toorg_is_used = this.$refs.sevenRef.dataobj.mrbase_sys_data_strategy_specified_staff_toorg_is_used
          obj.mrbase_sys_data_strategy_specified_staff_toorg = this.$refs.sevenRef.list
        }
        if (this.$refs.eightRef) {
          obj.mrbase_sys_data_strategy_specified_staff_tostaffs_is_used = this.$refs.eightRef.dataobj.mrbase_sys_data_strategy_specified_staff_tostaffs_is_used
          obj.mrbase_sys_data_strategy_specified_staff_tostaffs = this.$refs.eightRef.list
        }
        // console.log(this.$refs.oneRef)
        // console.log(this.$refs.twoRef)
        // console.log(this.$refs.threeRef)
        // console.log(this.$refs.fourRef)
        // console.log(this.$refs.fiveRef)
        // console.log(this.$refs.sixRef)
        // console.log(this.$refs.sevenRef)
        // console.log(this.$refs.eightRef)
        const res = await addData({ ...obj, ...this.baseInfo })
        if (res.code == 200) {
          this.$Message({ text: this.$t('添加成功') })
          this.$router.push({ name: 'data-access-strategy' })
        }
      }
    },
    cancel (val) {
      if (this.$store.state.uuid) {//修改
        this.$myConfirm({ content: this.$t('message_Confirm_the_cancellation_of_the_edit') }).then(res => {
          this.$router.push({ name: 'data-access-strategy' })
        }).catch(err => { })
      }
      else {//新增
        this.$emit('lastStep')
      }
    },
    updateSuccess () {
      this.$emit('updateSuccess')
    }
  },
};
</script>

<style scoped>
/deep/ .v-slide-group__wrapper {
  padding: 8px 0px;
}
/deep/ .v-tab--active {
  background-color: rgb(229, 238, 255) !important;
}
.v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 36px;
}
.v-tabs--vertical > .v-tabs-bar .v-tabs-slider {
  height: 36px;
  width: 4px;
}
/deep/ .v-slide-group__content {
  white-space: normal !important;
}
</style>
